export const MAINTENANCE_PAGE = {
  TITLE: 'Mantenimiento en progreso',
  MESSAGE: 'Estamos realizando un mantenimiento programado y volveremos pronto.',
  THANKS: 'Gracias por tu paciencia.',
  STATUS: 'Mantenimiento',
}
